import { render, staticRenderFns } from "./CardContentSeparator.vue?vue&type=template&id=f0772b9a&scoped=true"
import script from "./CardContentSeparator.vue?vue&type=script&lang=ts"
export * from "./CardContentSeparator.vue?vue&type=script&lang=ts"
import style0 from "./CardContentSeparator.vue?vue&type=style&index=0&id=f0772b9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0772b9a",
  null
  
)

export default component.exports